import { useQueries, type UseQueryResult } from '@tanstack/react-query';

export type CardIDDataType = {
    pan: string;
    expiry: string;
    gracePeriod: null;
    status: number;
    productName: string;
    productReference: string;
    accountNo: number;
    entityId: number;
    id: string;
    statusReasonCode: number;
    cashWithdrawalAllowed: boolean;
    dailyCashWithdrawalLimit: number;
    serialNumber: number;
};

const useCardIDsQuery = (cardIds: string[]): UseQueryResult<CardIDDataType>[] => {
    return useQueries({
        queries: cardIds.map(cardId => {
            return {
                queryKey: ['cardIDQuery', cardId],
                queryFn: async(): Promise<CardIDDataType> => {
                    const response = await fetch(`/api/Indue/cards/${cardId}`);
                    if (!response.ok) {
                        throw new Error('Failed to fetch card data');
                    }

                    const responseData = await response.json();

                    if (!responseData) {
                        throw new Error('Could not retrieve card data');
                    }

                    return responseData as CardIDDataType;
                },
                staleTime: Infinity,
            };
        }),
    });
};

export default useCardIDsQuery;

// SWAP ALL COMMENTED OUT CODE WITH THE ACTIVE CODE BELOW TO TEST CARD STATUS 0 USE CASE
// import { useEffect, useState } from 'react';

// interface DummyQueryResult {
//     data: CardIDDataType | undefined;
//     isLoading: boolean;
//     refetch: () => void;
// }

// const useCardIDsQuery = function(cardIds: string[]): DummyQueryResult[] {
//     const [allCards, setAllCards] = useState<CardIDDataType[]>([]);
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         setLoading(true);
//         fetch('/assets/data/card-id.json')
//             .then(res => {
//                 return res.json();
//             })
//             .then((data: CardIDDataType[]) => {
//                 setAllCards(data);
//                 setLoading(false);
//             });
//     }, []);

//     return cardIds.map(cardId => {
//         const card: CardIDDataType | undefined = allCards.find(c => {
//             return c.id === cardId;
//         });
//         return {
//             data: card,
//             isLoading: loading,
//             refetch(): void { /* no-op for dummy */ },
//         };
//     });
// };

// export default useCardIDsQuery;
